export const GET_POST = "GET_POST";
export const GET_MAIN_POST = "GET_MAIN_POST";
export const SET_POST = "SET_POST";
export const SET_MAIN_POST = "SET_MAIN_POST";
export const UPDATE_POST_TAG = "UPDATE_POST_TAG";
export const UPDATE_POST_TITLE = "UPDATE_POST_TITLE";
export const UPDATE_POST_SUMMARY = "UPDATE_POST_SUMMARY";